module.exports = __webpack_public_path__ + "img/001企业微信截图.5db9ea67.png";